import { Chart } from "react-google-charts";
import { useEffect, useState } from 'react'
import { Text, LoadComponent } from ".."
import api from "../../../services/api";
import { useApp } from "../../../contexts";
import { translateText } from "../../../helpers/util";

export const BarChartOccupationHistoryIndustrial = ({title='', industrialId}) => {
    const [occupationHistory, setOccupationHistory] = useState([])
    const [load, setLoad] = useState(false)
    const { language, translations, userCountry } = useApp();
    
    useEffect(() => {
        setLoad(true)
        api.get(`/industrial/${industrialId}/history/occupation`).then(response=>{
            const { occupationHistory } = response.data;
            setOccupationHistory(occupationHistory)
            setLoad(false)
            // console.log(load);
        });
       
    }, []);

    let data = [ 
        [translateText("Ano Trimestre", language, translations, userCountry), translateText("Ocupação", language, translations, userCountry), translateText("Disponibilidade", language, translations, userCountry)] 
    ];
    
    occupationHistory.forEach( occupation => {
        const result = [];

        result.push( occupation.trimestre + "T " + occupation.ano);
        result.push(parseFloat(occupation.estoque_total - occupation.vacancia));
        result.push(parseFloat(occupation.vacancia));

        data.push(result);
    })
    const options = {
        title: title,
        isStacked: true,
        legend: { position: 'bottom' },
        colors: ['#32587D', '#6db1cb'],
        chartArea: { 
            width: '80%', height: '70%'
        },
        
    };

    return (
        <>
            {/* <LoadComponent isLoading={load}> */}
                <Text style={styles.title}>{translateText("Histórico de Ocupação", language, translations, userCountry)}</Text>
                <Chart
                chartType="ColumnChart"
                data={data}
                options={options}
                width={"100%"}
                height={"100%"}
                />
            {/* </LoadComponent> */}
        </>
    )
}

const styles = {
    title: {
        fontSize: "14px",
        fontWeight: "600",
        color: "#7a7b7c"
    }
}